module.exports = __webpack_public_path__ + "static/media/insturctor3.55d6c7e8.png";